import {FlagIconByLocale} from '../../icons/flag-icons-by-locale'
import type {BioIconProps} from '../../icons/common-types'

export default function CanadaTopPicksLogo({locale, ...attributes}: BioIconProps) {
  return (
    <div className="domain_logo relative flex w-fit items-center gap-2 text-2xl font-semibold text-white tablet:gap-1 tablet:text-base">
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
        <path
          opacity="0.4"
          d="M11.5603 18.667H5.33366C3.86699 18.667 2.66699 19.867 2.66699 21.3337V29.3337H11.5603V18.667Z"
          fill="white"
        />
        <path
          d="M17.7735 13.333H14.2135C12.7469 13.333 11.5469 14.533 11.5469 15.9997V29.333H20.4402V15.9997C20.4402 14.533 19.2535 13.333 17.7735 13.333Z"
          fill="white"
        />
        <path
          opacity="0.4"
          d="M26.6671 22.667H20.4404V29.3337H29.3338V25.3337C29.3338 23.867 28.1338 22.667 26.6671 22.667Z"
          fill="white"
        />
        <path
          d="M20.0132 6.46698C20.4266 6.05365 20.5866 5.56032 20.4532 5.13365C20.3199 4.70698 19.9066 4.40032 19.3199 4.30699L18.0399 4.09365C17.9866 4.08032 17.8666 4.0003 17.8399 3.94696L17.1332 2.53363C16.5999 1.45363 15.3866 1.45363 14.8532 2.53363L14.1466 3.94696C14.1199 4.0003 13.9999 4.08032 13.9466 4.09365L12.6666 4.30699C12.0799 4.40032 11.6799 4.70698 11.5332 5.13365C11.3999 5.56032 11.5599 6.05365 11.9732 6.46698L12.9599 7.46698C12.9999 7.50698 13.0532 7.66699 13.0399 7.72032L12.7599 8.94696C12.5466 9.85363 12.8932 10.267 13.1199 10.4403C13.3466 10.6003 13.8399 10.8136 14.6532 10.3336L15.8532 9.62698C15.9066 9.58698 16.0799 9.58698 16.1332 9.62698L17.3332 10.3336C17.7066 10.5603 18.0132 10.627 18.2532 10.627C18.5332 10.627 18.7332 10.5203 18.8532 10.4403C19.0799 10.2803 19.4266 9.86696 19.2132 8.94696L18.9332 7.72032C18.9199 7.65365 18.9599 7.50698 19.0132 7.46698L20.0132 6.46698Z"
          fill="white"
        />
      </svg>

      <span>Canada Top Picks</span>
      <FlagIconByLocale
        locale={locale}
        className="absolute -right-6 -top-3 size-8 shrink-0 -rotate-12 tablet:-right-4 tablet:-top-1 tablet:size-5"
      />
    </div>
  )
}
